import {Outlet, useLocation} from 'react-router-dom';
import {useState, useEffect} from 'react';
import useRefreshToken from '../hooks/useRefreshToken';
import useAuth from '../hooks/useAuth';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const {auth, persist} = useAuth();
    const location = useLocation();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try{
                await refresh();
            }catch(err){
                console.error(err)
            }finally{
                isMounted && setIsLoading(false);
            }
        }

        !auth?.accessToken ? verifyRefreshToken() : setIsLoading(false);

        return () => isMounted = false;
    }, []);

    useEffect(() => {
        if (!persist) return;

        const inFlightRef = PersistLogin._inFlightRef || (PersistLogin._inFlightRef = { v: false });
        const lastKeyRef = PersistLogin._lastKeyRef || (PersistLogin._lastKeyRef = { v: null });
        const lastTsRef  = PersistLogin._lastTsRef  || (PersistLogin._lastTsRef  = { v: 0 });

        if (inFlightRef.v) return;
        if (lastKeyRef.v === location.key) return;
        const now = Date.now();
        if (now - lastTsRef.v < 3000) return;

        inFlightRef.v = true;
        lastKeyRef.v = location.key;

        (async () => {
            try {
                await refresh();
            } catch (e) {
                //swallow
            } finally {
                inFlightRef.v = false;
                lastTsRef.v = Date.now();
            }
        })();
    }, [location.key, persist, refresh]);

    return(
        <>
            {!persist ? <Outlet/> : isLoading ? <p>Loading...</p> : <Outlet/>}
        </>
    )
}

export default PersistLogin;